import { withSentry } from '@sentry/remix';
import { AppProvider } from '@/providers/AppProvider';
import type { ReactNode } from 'react';
import type { LinksFunction } from 'react-router';
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';

export const links: LinksFunction = () => [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
  },
];

export function Layout({ children }: { children: ReactNode }) {
  return (
    <html lang='ja'>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <Meta />
        <Links />
        <style>
          {`
          .root {
            margin: 32px 16px 8px;
          }
          .root:has(> .page-layout) {
            margin: 0;
          }
          `}
        </style>
        {/* Load the Firebase SDKs before loading this file */}
        {/* <script src='/__/firebase/init.js'></script> */}
      </head>
      <body>
        <div className='root'>{children}</div>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

function App() {
  // useEffect(() => {
  //   const setupVConsole = async () => {
  //     const VConsole = (await import('vconsole')).default;
  //     new VConsole();
  //   };
  //   setupVConsole();
  // }, []);

  return (
    <AppProvider>
      <Outlet />
    </AppProvider>
  );
}

export default withSentry(App);

export function HydrateFallback() {
  return <p>Loading...</p>;
}
